import {InterventionStatus} from "@/medication-checkup/interfaces/interventions";

/**
 * Whether the status calls for a posology in words: a new posology on a
 * treatment kept, or the one of a treatment added. A replacement is said by
 * its product and a stop by the analysis that motivates it.
 */
export const requiresOutcome = (status: InterventionStatus): boolean => {
    return status === 'posology_modified' || status === 'added';
};

/**
 * Whether the status names a product of its own, beside the line.
 */
export const namesProduct = (status: InterventionStatus): boolean => {
    return status === 'replaced' || status === 'added';
};
